import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  IconButton,
} from "@mui/material";
import { Shop as GooglePlayIcon } from "@mui/icons-material"; // Ensure the correct Google Play Store icon is imported
import Question from "./ShadowQuestion";
import TemplateOption from "./ShadowTemplate";
import { LogflareService } from "../../../crashLogging/LogFlare";
const ModeSelection = ({ productionData, onHorizonChange }) => {
  const [mode, setMode] = useState("question"); // Manage the current mode

  // Handle mode change
  const handleModeChange = (event, newMode) => {
    if (newMode !== null) {
      setMode(newMode);
    }
    LogflareService.sendDataToLogflare("SHADOW MODE CHANGE:", 1);
  };

  const messages = [
    "Analyzing your choice...",
    "Calculating shadow cover",
    "Almost there...",
    "Ready to proceed!",
  ];

  return (
    <Card
      sx={{
        backgroundColor: "#28293e",
        mb: 3,
        px: { xs: 1.5, sm: 4 },
        py: { xs: 2, sm: 5 },
        width: "80%",
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <CardContent>
        {/* Toggle Button Group */}
        <ToggleButtonGroup
          value={mode}
          exclusive
          onChange={handleModeChange}
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 4,
          }}
        >
          <ToggleButton value="question" sx={{ color: "#fff" }}>
            Text to AI
          </ToggleButton>
          <ToggleButton value="settings" sx={{ color: "#fff" }}>
            Image to AI
          </ToggleButton>
        </ToggleButtonGroup>

        {/* Conditionally Render Modes */}
        {mode === "overview" && (
          <TemplateOption onHorizonChange={onHorizonChange} />
        )}

        {mode === "question" && (
          <Question
            productionData={productionData}
            onAnswerSelected={onHorizonChange}
            messages={messages}
          />
        )}

        {mode === "settings" && (
          <Box textAlign="center" color="#fff">
            <Typography variant="h5" sx={{ mb: 3 }}>
              This function is only available in our app:
            </Typography>
            <a
              href="https://play.google.com/store/apps/details?id=tech.gpsolar.gpsolar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                alt="Get it on Google Play"
                src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
                style={{ width: "200px", height: "auto" }}
              />
            </a>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ModeSelection;
